module.exports = function(str){
	var ua = window.navigator.userAgent.toLowerCase();
	return (ua.indexOf(str) !== -1);
}



// WEBPACK FOOTER //
// ./es2015/module/ua.js